export default "__VITE_ASSET__DOxk6Zk0__"